import React from 'react';
import { motion } from 'framer-motion'; // Importiere framer-motion
import BlockDeliveryMehod from "../BlockAddress/components/BlockDeliveryMehod";
import { useReduxStore } from '../../../../redux/checkoutredux/ReduxCheckoutContext.tsx';
import NextPage from "../BlockElements/NextPage";
import BlockSummary from "../BlockElements/BlockSummary";

const PageShipping = () => {
  const store = useReduxStore(); 

  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={{
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 }
      }}
      transition={{ duration: 0.7 }}
    >
      <div className="ips-pageshipping">
        <div className="my-4"><BlockSummary pagetype="shipping" store={store}/></div>
        {/* <div className="my-4"><BlockPickup /></div> */}
        <BlockDeliveryMehod store={store} />
        <div className="my-4"><NextPage pagetype="shipping" store={store}/></div>
        {/* Erste absolut innere|linke Spalte */}
        {/* Abstands Reihe */}
        <div className="row my-4"></div>
        {/* Abstands Reihe */}
        <div className="row my-4"></div>
      </div>
    </motion.div>
  );
};

export default PageShipping;